module.exports = __webpack_public_path__ + "fonts/Comfortaa-Bold.801965b0.ttf";